import {Referral} from '@raf/core/domain/Referral';
import {ReferralApplication} from '@raf/core/application';

const getReferral = async (): Promise<Referral | undefined> => {
  return await ReferralApplication.getReferral();
};

export {getReferral};
